<template>
  <Spinner v-if="isLoading" />
	<div class="grid nested-grid">
		<div class="col-12">								
			<div class="card fluid cardheader">
				<div class="col-12">
					<h5 class="stationsHeader">{{ translated('reportstitle').toUpperCase() }}</h5>           
				</div>												
			</div>	
    </div>


    		<div class="col-3" v-for="report in reports" :key="report.id" v-on:click="reportSelected(report)" >
      <!-- report.Name -->
      <!-- <a v-auth-href="{token: 'usertoken'}" :href="apilocation + report.Endpoint + '?id=' + report.Id" download> -->
      <!--<a :href="apilocation + report.Endpoint + '?id=' + report.Id" download>-->
        <div class="card fluid repordcard">
            <h3><i class="pi pi-file-excel fileiconreport"></i> {{ report.Name }} </h3>
            <h5> {{ report.Description }} </h5>		            	
        </div>
      <!--</a>-->
    </div>
  </div> 




<Dialog v-model:visible="snapshotDialogIsOpen" :style="{width: '30vw'}" :modal="true" class="globalDialog">
    <template #header>
      <span class="p-dialog-title">{{ translated('snapshotselector') }}</span>
    </template>	

    <div class="card fluid">       

      <div class="field grid">
        <label for="name1" class="col-12 md:col-6 mb-md-0">{{ translated('snapshotcombolabel') }}</label>
        <div class="col-12 md:col-6">
          <Dropdown v-model="snapshotid" :options="snapshotesAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('snapshotcombotip')" :class="{'p-invalid':errDan}" />																	
        </div>                        
      </div>		

      <div class="field grid" v-if="tmpSecondsnapshotname != '' && tmpSecondsnapshotname != null">
        <label for="name1" class="col-12 md:col-6 mb-md-0">{{ translated('snapshotselectlabelcompare') }}</label>
        <div class="col-12 md:col-6">
          <Dropdown v-model="secondsnapshotid" :options="snapshotesAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('snapshotcombotip')" :class="{'p-invalid':errDan}" />																	
        </div>                        
      </div>	
        
    </div>

    <template #footer>
      <Button :label="translated('canclebutton')" icon="pi pi-times" @click="closeSnapshotDialog" class="p-button-text"/>
      <Button :label="translated('snapshotselectlabel')" icon="pi pi-check" @click="snapshotSelected" autofocus />
    </template>
</Dialog>

</template>
 

<script>
import createHttp from "@/services/http";
import { computed } from "vue";
import store from "@/store";
import Spinner from "@/components/Spinner.vue"
//import axios from "axios";


export default {
  components: { Spinner },   
  data() {
    return {
        reports: [],
        apilocation: '',
        isLoading: false,
        usertoken: computed(() => store.getters.getToken),
        translated: computed(() => store.getters.getTranslate),
        tmpLastEndpoint: '',
        tmpLastId: '',
        tmpSecondsnapshotname: '',
        snapshotid: null,
        secondsnapshotid: null,
        snapshotDialogIsOpen: false,
        snapshotesAllOptions: [],
    }
  },
  async mounted() {
    this.apilocation = process.env.VUE_APP_API_ROOT_FOLDER;
    const http = createHttp(true); 

    const opts = {
      year:   "numeric",
      month:  "2-digit",
      day:    "2-digit",
      hour:   "2-digit",
      minute: "2-digit",
      second: "2-digit"
    };

    
    const resultSnapshots = await http.get(process.env.VUE_APP_API_FOLDER + "/GetSnapshotRecords");
    resultSnapshots.data.forEach(item => {        
        const elSnapshot = {label:  this.formatDate(item.SnapshotDate), value: item.Id}
        this.snapshotesAllOptions.push(elSnapshot)
    })


    const result = await http.get(process.env.VUE_APP_API_FOLDER + "/GetReports");
    if(result.status==200){
        this.reports = result.data
    }
  },
  methods: { 
    reportSelected(report) {
      if (report.IsReport === 0 || report.IsReport === false) {
        this.$router.push({ name: report.Endpoint });
        return;
      }

      this.openSnapshotSelector(report.Endpoint, report.Id, report.SecondSnapshotName);
    },
    
    formatDate(dateTime) {
        if (!dateTime) return '';

        const d = new Date(dateTime);

        // Use browser’s locale (e.g. “sl-SI” for Slovenian) and show day/month/year
        return d.toLocaleString(
            'sl-SI',
            navigator.language,
            {
                year:   'numeric',
                month:  '2-digit',
                day:    '2-digit',
                hour:   "2-digit",
                minute: "2-digit",
                second: "2-digit"
            }
        );    
    }, 
    getParameterCaseInsensitive(object, key) {
      return object[Object.keys(object).find(k => k.toLowerCase() === key.toLowerCase())]
    },
    snapshotSelected(){
      // if(this.snapshotid == null || this.snapshotid == '') return

      debugger;
      if(this.tmpSecondsnapshotname != undefined && this.tmpSecondsnapshotname != null && this.secondsnapshotname != '') {
        if(this.secondsnapshotid == null || this.secondsnapshotid == '' || this.snapshotid == null || this.snapshotid == '') return
      }

      this.downloadReport(this.tmpLastEndpoint, this.tmpLastId, this.snapshotid, this.tmpSecondsnapshotname, this.secondsnapshotid)
      this.closeSnapshotDialog();
    },
    closeSnapshotDialog(){
      this.snapshotDialogIsOpen = false
    },
    openSnapshotSelector(endpoint, id, secondsnapshotname) {
      this.snapshotid = null;
      this.tmpLastEndpoint = endpoint;
      this.tmpLastId = id;
      this.tmpSecondsnapshotname = secondsnapshotname;
      
      this.snapshotDialogIsOpen = true
    },
    downloadReport(endpoint, id, snapshotid, secondsnapshotname, secondsnapshotid) {

      this.isLoading =true;

      var url = this.apilocation + endpoint + '?id=' + id;
      if(snapshotid != null && snapshotid != '') url = url + '&snapshotId=' + snapshotid
      if(secondsnapshotname != null && secondsnapshotname != '') url = url + '&' + secondsnapshotname + '=' + secondsnapshotid

      console.log(url);
      const http = createHttp(true); 

      const authHeader = {}
      authHeader["Authorization"] = `bearer ${store.state.token}`

      http.get(url, {responseType: 'blob'}).then((response) => {        

        const tmpFileName = this.getParameterCaseInsensitive(response.headers, "filename")
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', tmpFileName);
        document.body.appendChild(link);
        link.click();
        
        this.isLoading = false;
      });
    }
  }
}
</script>

<style scoped>
.card.fluid.repordcard {
    height: 200px;
}

.card.fluid.repordcard:hover {
    background:#00BCD4;
    color:white;
    cursor:pointer;
}

h3, .fileiconreport {
  font-size: 1.4rem;
}
</style>
